import { useEffect } from "react";
import { useCourseKit } from "./provider.tsx";

export const coursePath = (courseSlug: string): string => `/cursus/${courseSlug}`;

export const lessonPath = (courseSlug: string, lessonSlug: string): string =>
  `/cursus/${courseSlug}/${lessonSlug}`;

export const loginPath = (next: string): string => `/inloggen?next=${encodeURIComponent(next)}`;

/**
 * Post-login target from `?next=`: only a same-origin path, so the login page
 * cannot be used to bounce visitors to another site (or back to itself).
 */
export const sanitizeNext = (raw: string | null): string => {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return "/";
  try {
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname.startsWith("/inloggen")) return "/";
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "/";
  }
};

/** `<page> · <brand>` in the browser tab; null leaves the title alone (e.g. while loading). */
export const useDocumentTitle = (title: string | null): void => {
  const { brand } = useCourseKit();
  useEffect(() => {
    if (title !== null) document.title = `${title} · ${brand.name}`;
  }, [title, brand.name]);
};
